import React, { useContext, useState, useEffect } from 'react';
import { Container, Row, Col, Spinner, Tabs, Tab } from 'react-bootstrap';
import Filter from './components/filter/filter';
import ReportContainer from './components/report-container/report-container';
import AuditConfirmationContainer from './components/audit-confirmation-container/audit-confirmation-container';
import CertificationOfHoldingsContainer from './components/certification-of-holdings-container/certification-of-holdings-container';

import { useHistory } from "react-router-dom";
import ReportsService from "../../../../services/reports-service";

import './maker-reports-module.scss';
import { IdentityContext } from '../../../../context/identity-context';

const MakerReportsModule = () => {
    const [items, setItems] = useState([]);
    const [auditConfirmations, setAuditConfirmations] = useState([]);
    const [certificationHoldings, setCertificationHoldings] = useState([]);
    
    // Separate filtered state variables for each list
    const [filteredItems, setFilteredItems] = useState([]);
    const [filteredAuditConfirmations, setFilteredAuditConfirmations] = useState([]);
    const [filteredCertificationHoldings, setFilteredCertificationHoldings] = useState([]);

    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState("outstanding");

    const reportsService = new ReportsService();
    const history = useHistory();

    const { user, role } = useContext(IdentityContext);

    useEffect(() => {
        let isMounted = true; 

        const getReports = async () => {
            try {
                const result = await reportsService.getReports("rr_maker", user.attributes);
                if (isMounted) {
                    setItems(result.items);
                    setFilteredItems(result.items);

                    setAuditConfirmations(result.auditConfirmations);
                    setFilteredAuditConfirmations(result.auditConfirmations);

                    setCertificationHoldings(result.certificationHoldings);
                    setFilteredCertificationHoldings(result.certificationHoldings);

                    // console.log('maker result', result);
                }
            } catch (error) {
                if (isMounted) {
                    console.error('Fetching error:', error);
                    history.push(`/internal-server-error`);
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        getReports();

        return () => {
            isMounted = false;
        };
    }, []);

    const handleFilterChange = (filters) => {
        const { status, issuers } = filters;

        if (activeTab === "outstanding") {
            const filtered = items.filter((item) => {
                const matchesStatus = status.length ? status.includes(item.status) : true;
                const matchesIssuer = issuers.length ? issuers.includes(item.securityIssuer) : true;
                return matchesStatus && matchesIssuer;
            });
            setFilteredItems(filtered);
        } else if (activeTab === "audit") {
            const filtered = auditConfirmations.filter((confirmation) => {
                const matchesStatus = status.length ? status.includes(confirmation.status) : true;
                const matchesIssuer = issuers.length ? issuers.includes(confirmation.issuer) : true;
                return matchesStatus && matchesIssuer;
            });
            setFilteredAuditConfirmations(filtered);
        } else if (activeTab === "certification") {
            const filtered = certificationHoldings.filter((cert) => {
                const matchesStatus = status.length ? status.includes(cert.status) : true;
                const matchesBpId = issuers.length ? issuers.includes(cert.bpId) : true;
                return matchesStatus && matchesBpId;
            });
            setFilteredCertificationHoldings(filtered);
        }
    };

    // Choose the items to pass to the Filter component based on the active tab
    const filterItems = activeTab === "outstanding" 
        ? items 
        : activeTab === "audit" 
            ? auditConfirmations 
            : certificationHoldings;

    return (
        <Container fluid className="maker-reports-module-container">
            {loading ? (
                <div className="loading-container">
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </div>
            ) : (
                <>
                    <Tabs activeKey={activeTab} onSelect={(tab) => setActiveTab(tab)} className="mb-3">
                        <Tab eventKey="outstanding" title="Outstanding Balances" />
                        <Tab eventKey="audit" title="Audit Confirmation" />
                        <Tab eventKey="certification" title="Certification of Holdings" />
                    </Tabs>
                    <Row>
                        <Col xs={12} md={3} className="panel">
                            <Filter 
                                items={filterItems} 
                                filter={{ status: [], issuers: [] }} 
                                onFilterChange={handleFilterChange} 
                            />
                        </Col>
                        <Col xs={12} md={9}>
                            {activeTab === "outstanding" && <ReportContainer items={filteredItems} />}
                            {activeTab === "audit" && <AuditConfirmationContainer items={filteredAuditConfirmations} />}
                            {activeTab === "certification" && <CertificationOfHoldingsContainer items={filteredCertificationHoldings} />}
                        </Col>
                    </Row>
                </>
            )}
        </Container>
    );
};

export default MakerReportsModule;
